<template>
    <div class="catalog-limiter">
        <button
            ref="button"
            v-click-outside="closeListWithDelay"
            class="catalog-limiter__btn btn btn--small"
            @click="toggleList"
        >
            <span class="catalog-limiter__label" v-text="resultsPP" />
            <span class="catalog-limiter__arrow">
                <SortIcon
                    width="14"
                    height="9"
                    :class="{ 'icon--rotate-180': listOpen }"
                />
            </span>
        </button>

        <div
            v-if="listOpen"
            ref="list"
            class="catalog-limiter__list"
            :class="{ 'is-visible': listOpen }"
            tabindex="0"
            role="listbox"
            @keydown="onKeyDown"
        >
            <button
                v-for="(limitOption, index) in pagerOptions"
                :key="index"
                role="option"
                class="catalog-limiter__list-item btn--clear"
                :class="{
                    'is-active': resultsPP == limitOption,
                    'is-highlighted': highlightedIndex === index
                }"
                @click="setPerPage(limitOption)"
            >
                <span>{{ limitOption }}</span>
            </button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import SortIcon from '@icons/sort.svg'

export default {
    components: {
        SortIcon
    },
    data() {
        return {
            listOpen: false,
            highlightedIndex: 0
        }
    },
    computed: {
        ...mapState({
            resultsPP: ({ params }) => params.resultsPP,
            pagerOptions: ({ options }) => options.pager.options
        })
    },
    methods: {
        ...mapActions(['setParams', 'getProducts']),
        setPerPage(perPage) {
            this.setParams({ resultsPP: perPage, p: 1 })
            this.getProducts()
            this.listOpen = false
        },
        closeListWithDelay() {
            setTimeout(() => {
                this.listOpen = false
            }, 200)
        },
        toggleList() {
            this.listOpen = !this.listOpen
            this.$nextTick(() => {
                if (this.listOpen) {
                    this.$refs.list.focus()
                }
            })
        },
        onKeyDown(event) {
            if (event.code === 'Escape') {
                this.listOpen = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.catalog-limiter {
    position: relative;
    z-index: 6;

    &__btn {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 84px;
        height: 40px;
        padding: 0 18px;
        background: #fff;
        border-radius: $button-radius;
        z-index: 3;

        &:hover {
            svg {
                path {
                    fill: white;
                }
            }
        }

        @media #{$media-to-sm} {
            width: 69px;
            height: 26px;
            min-height: 26px;
        }
    }

    &__label {
        font-size: 16px;
        font-weight: 600;
        @media #{$media-to-sm} {
            font-size: 12px;
        }
    }

    &__arrow {
        svg {
            @media #{$media-to-sm} {
                width: 9px;
            }

            path {
                fill: $sherpa-blue;
            }
        }
    }

    &__list {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: #fff;
        margin-top: -18px;
        padding-top: 18px;
        box-shadow: 0 30px 40px 0 rgba(47, 49, 70, 0.1);
        overflow: hidden;
    }

    &__list-item {
        display: block;
        text-align: start;
        cursor: pointer;
        width: 100%;
        position: relative;
        z-index: 9999999;
        padding: 12px 16px;

        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px;

        &.is-active,
        &:hover,
        &:focus {
            background-color: $sherpa-blue-light;
        }

        @media #{$media-to-sm} {
            font-size: 12px;
            padding: 0.5rem;
        }
    }
}
</style>
